export default "__VITE_ASSET__CvN9SS03__"